import { createSelector } from 'reselect';

const selectLMSCertificates = (state: any) => state.lmsCertificates;

export const selectLMSCertificatesCurrentItem = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.current);

export const selectLMSCertificatesListItems = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.list);

export const selectLMSCertificatesItemById = (itemId: any) =>
    createSelector(selectLMSCertificatesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLMSCertificatesQueryItems = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.query);

export const selectLMSCertificatesCreatedItem = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.create);

export const selectLMSCertificatesUpdatedItem = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.update);

export const selectLMSCertificatesReadItem = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.read);

export const selectLMSCertificatesDeletedItem = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.delete);

export const selectLMSCertificatesSearchedItems = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.search);

export const selectLMSCertificatesItemsCount = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.count);

export const selectLMSCertificatesItemsFilter = createSelector([selectLMSCertificates], (lmsCertificates) => lmsCertificates.filter);
